module.exports = __webpack_public_path__ + "static/media/social.47b00e6c.svg";